import { useEffect, useState } from 'react'
import { useScrollIntoViewOnMount } from '../labs/useScrollIntoView'

// Post-commit reflection notice, shown UNDER the transcript (mic stays on) so the
// player keeps seeing what they said while we capture any final reflection. A subtle
// bar fills left→right over `seconds` so it's obvious the window is ticking, then onDone.
export const ReflectionNotice = ({ seconds, onDone }: { seconds: number; onDone: () => void }) => {
  const [remaining, setRemaining] = useState(seconds)
  const [filled, setFilled] = useState(false) // flips on first paint so the CSS bar animates

  useEffect(() => {
    requestAnimationFrame(() => setFilled(true))
    const start = performance.now()
    const id = window.setInterval(() => {
      const left = Math.max(0, seconds - (performance.now() - start) / 1000)
      setRemaining(left)
      if (left <= 0) {
        window.clearInterval(id)
        onDone()
      }
    }, 100)
    return () => window.clearInterval(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const scrollRef = useScrollIntoViewOnMount<HTMLDivElement>()
  return (
    <div ref={scrollRef} className="text-center">
      <div className="text-sm font-semibold text-[#398874]">✅ Answer committed</div>
      <p className="mt-1 text-sm text-gray-500">
        Mic’s still on. Finish any last thoughts out loud.
      </p>

      {/* Subtle left→right timer bar over the reflection window. */}
      <div className="mx-auto mt-3 h-1 w-full max-w-xs overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-[#398874]"
          style={{ width: filled ? '100%' : '0%', transition: `width ${seconds}s linear` }}
        />
      </div>
      <div className="mt-1.5 text-xs text-gray-400">Moving on in {Math.ceil(remaining)}s…</div>
    </div>
  )
}
